import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
  ChartData,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Registrar los componentes necesarios para Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);



interface GroupBarChartProps {
  dataObject: object;
  campoTitulo: string;
  camposDatos: string[];
  tituloGrafica?: string;

}

const GroupBarChart: React.FC<GroupBarChartProps> = ({ dataObject, campoTitulo, camposDatos, tituloGrafica }) => {



  const labels = Array.isArray(dataObject)
    ? (dataObject as any[]).map(item => item[campoTitulo])
    : [];
  const colors = ['#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#f1c40f'];
  const datasets = camposDatos.map((campo, index) => ({
    label: campo,
    data: (dataObject as any[]).map(item => item[campo]),
    backgroundColor: colors[index % colors.length],
  }));

  const data: ChartData<'bar'> = {
    labels,
    datasets,
  };

  const options: ChartOptions<'bar'> = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: tituloGrafica ? true : false,
        text: tituloGrafica,
      },
    },
    scales: {
      x: {
        stacked: false,
      },
      y: {
        beginAtZero: true,
      },
    },
  };




  return <Bar options={options} data={data} />;
};

export default GroupBarChart;
